import React, { useState, useEffect } from "react";
import axios from "axios";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { Grid, TextField, MenuItem, Button as MUIButton } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../Assets/Images/logo.png'


export default function ReportsPage() {
  const [filters, setFilters] = useState({
    searchBy: "",
    payment: "",
    status: "",
    type: "",
    fromDate: "",
    toDate: "",
    employee: ""
  });

  const [bookings, setBookings] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]); // current page only
  const userID=localStorage.getItem('_id')
  const companyName=localStorage.getItem('companyName')
  const [page, setPage] = useState(1); // current page
  const [limit, setLimit] = useState(25); // items per page
  const [filtersSearched, setFiltersSearched] = useState(false);
  //const [total, setTotal] = useState(0); // total results

  const accountType=localStorage.getItem("accountType")

const isFilterApplied = () => {
  return Object.values(filters).some(v => v !== "");
};

const handleResetFilters = () => {
  setFilters({
    searchBy: "",
    payment: "",
    status: "",
    type: "",
    fromDate: "",
    toDate: "",
    employee: ""
  });
  setFiltersSearched(false); // reset search state
  setPage(1);
  fetchBookings(false); // reload default last 25
};

const handleDownloadPDF = async () => {
  const doc = new jsPDF();

  // 1. Load the image
  const imgUrl =logo;
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.src = imgUrl;

  img.onload = () => {
    const imgWidth = 50;
    const imgHeight = (img.height / img.width) * imgWidth;
    const pageWidth = doc.internal.pageSize.getWidth();
    const xImg = (pageWidth - imgWidth) / 2;

    // Add the image at top center
    doc.addImage(img, "PNG", xImg, 10, imgWidth, imgHeight);

    // 2. Add title below the image
    const title = "Bookings Report";
    doc.setFontSize(16);
    const textWidth = doc.getTextWidth(title);
    const xText = (pageWidth - textWidth) / 2;
    const yText = 10 + imgHeight + 10;
    doc.text(title, xText, yText);
   // Add company name below the title
    doc.setFontSize(12);
const xCompany = 14; // left-aligned
const companyY = yText + 8;
doc.text(`Company Name: ${companyName}`, xCompany, companyY);

// Generate extra info line
// 3. Meta Info Block (Name/ID & Generated/Date Range)
doc.setFontSize(10);
doc.setTextColor(0, 0, 0);

const yMetaStart = yText + 15;

let empInfo = "";
let empId = "";
let dateRange = "All";
const generatedOn = new Date().toLocaleDateString("en-GB");
if (filters.employee) {
  const emp = employees.find(e => e._id === filters.employee);
  if (emp) {
    empInfo = `${emp.fName} ${emp.lName}`;
    empId = emp.id;
  }
}

if (filters.fromDate && filters.toDate) {
  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  dateRange = `${formatDate(filters.fromDate)} to ${formatDate(filters.toDate)}`;
}

// First Row
let yCurrent = yText + 15
const pageWidth2 = doc.internal.pageSize.getWidth();
const rightAlignX = pageWidth2 - 14;

if (filters.employee && empInfo && empId) {
  doc.text(`Emp Name: ${empInfo}`, 14, yCurrent);
  doc.text(`Generated On: ${generatedOn}`, rightAlignX, yCurrent, { align: "right" });

  yCurrent += 6;

  doc.text(`Emp ID: ${empId}`, 14, yCurrent);
  doc.text(`Date Range: ${dateRange}`, rightAlignX, yCurrent, { align: "right" });

  yCurrent += 4;
} else {
  doc.text(`Generated On: ${generatedOn}`, rightAlignX, yCurrent, { align: "right" });
  doc.text(`Date Range: ${dateRange}`, rightAlignX, yCurrent + 6, { align: "right" });

  yCurrent += 10;
}
    


    // 3. Table Data
    const tableData = bookings.map((b, index) => [
      bookings.length - ((page - 1) * limit) - index,
      b.bookingId,
      `${b?.booking_contact_infos?.[0]?.fName || ""} ${b?.booking_contact_infos?.[0]?.lName || ""}`,
      b?.vehicaltypes[0]?.vehicalName || "",
      b.bookingType,
      b?.failStatus === "Failed"
        ? "Failed"
        : b?.cancelStatus === "Cancelled"
        ? "Cancelled"
        : b?.status === "0"
        ? "Pending"
        : b?.status === "1"
        ? "Accepted"
        : b?.status === "2"
        ? "Processing"
        : b?.status === "3"
        ? "Completed"
        : b?.status === "4"
        ? "No Show"
        : b?.status === "5"
        ? "On Spot Cancel"
        : b?.status === "6"
        ? "Refunded"
        : "",
      (b?.total || 0).toFixed(2) + " €",
      b?.paymentType === "bankInvoice" ? "Bank Invoice" : b?.paymentType || "",
      new Intl.DateTimeFormat("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC"
  }).format(parseInt(b?.date)),
  // New: B.Date & Time
  new Date(b?.createdAt).toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })
]);
   

    // 4. Add Table
    autoTable(doc, {
      head: [
        [
          "#",
          "Booking ID",
          "Customer Name",
          "Vehicle",
          "Type",
          "Status",
          "Fare",
          "Payment",
          "Ride Date",
          "B.Date & Time"
        ],
      ],
      body: tableData,
      // startY: yText + 10,
      startY: companyY + 17,
      styles: { fontSize: 8 },
      headStyles: {
        fillColor: "#09314F", // RGB for a blue header background
        textColor: [255, 255, 255], // white text
        halign: "center"
      },
    });

    // 5. Save PDF
    doc.save("bookings_report.pdf");
  };

  img.onerror = (err) => {
    console.error("Failed to load image", err);
    alert("Unable to load logo for PDF.");
  };
};


const totalPages = Math.ceil(bookings.length / limit);

const fetchBookings = async (applyFilters = false) => {
  try {
    const payload = { userID };

    if (applyFilters) {
      payload.searchBy = filters.searchBy;
      payload.payment = filters.payment;
      payload.status = filters.status;
      payload.type = filters.type;
      payload.employee = filters.employee;
      payload.fromDate = filters.fromDate
        ? new Date(filters.fromDate).getTime()
        : null;
      payload.toDate = filters.toDate
        ? new Date(filters.toDate).getTime()+86399999
        : null;
    }

    const { data } = await axios.post(
      `${process.env.REACT_APP_URL}api/booking/getBusinessAgentBookingsFiltered`,
      payload
    );

    if (data.status === 200) {
      setBookings(data.data);
      setPage(1); // reset to first page
    }
  } catch (err) {
    console.error("Error fetching bookings", err);
  }
};

// Update displayed bookings when page or limit changes
useEffect(() => {
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  setFilteredBookings(bookings.slice(startIndex, endIndex));
}, [page, limit, bookings]);

useEffect(() => {
  fetchBookings(false);
}, []);

const handleSearch = () => {
    setFiltersSearched(true);
  fetchBookings(true);
};

  // Fetch last 30 bookings on page load
  useEffect(() => {
    fetchBookings(false);
  }, []);

const fetchEmployees = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}api/user/fetchEmployees`,
        {
          companyName: companyName,
        }
      );
      setEmployees(data.data);
      console.log("data.data",data.data)
    } catch (error) {
      console.error("Failed to fetch employees:", error);
      //toast.error("Failed to fetch employees.");
    } 
  };

  useEffect(() => {
    fetchEmployees();
  }, [companyName]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

    


  return (
    <div className="container-fluid m-0 mt-5 px-5 ">
      <h4>Reports</h4>
      <p style={{ color: "#6c757d" }}>Dashboard / Bookings / Booking Report</p>

      {/* Filter Row */}
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Search by"
            name="searchBy"
            value={filters.searchBy}
            onChange={handleInputChange}
          >
            <MenuItem value="">Search by...</MenuItem>
            <MenuItem value="bookingDate">Booking Date</MenuItem>
            <MenuItem value="rideDate">Ride Date</MenuItem>
            {/* <MenuItem value="returnDate">Return Date</MenuItem> */}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Payment"
            name="payment"
            value={filters.payment}
            onChange={handleInputChange}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="cash">Cash</MenuItem>
            <MenuItem value="card">Card</MenuItem>
            <MenuItem value="Bank Invoice">Bank Invoice</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Status"
            name="status"
            value={filters.status}
            onChange={handleInputChange}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value={"0"}>Pending</MenuItem>
            <MenuItem value={"1"}>Accepted</MenuItem>
            <MenuItem value={"2"}>Processing</MenuItem>
            <MenuItem value={"3"}>Completed</MenuItem>
            <MenuItem value={"5"}>No Show</MenuItem>
            <MenuItem value={"6"}>On Spot Cancel</MenuItem>
            <MenuItem value={"7"}>Refunded</MenuItem>
            <MenuItem value="Cancelled">Cancelled</MenuItem>
            <MenuItem value="Failed">Failed</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Type"
            name="type"
            value={filters.type}
            onChange={handleInputChange}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="One Way">One Way</MenuItem>
            <MenuItem value="Return">Return</MenuItem>
          </TextField>
        </Grid>
        {accountType !== "Agent" && (
  
        <Grid item xs={12} sm={6} md={2}>
        <TextField
          select
          fullWidth
          size="small"
          label="Employee"
          name="employee"
          value={filters.employee}
          onChange={handleInputChange}
        >
          {/* Default option */}
          <MenuItem value="">Select Employee</MenuItem>

          {/* Show only active employees */}
          {employees
            .filter((emp) => emp.isUserApproved === 1) 
            .map((emp) => (
              <MenuItem key={emp._id} value={emp._id}>
                {`${emp.fName} ${emp.lName} (${emp.id})`}
              </MenuItem>
            ))}
        </TextField>
      </Grid>
      )}
        {/* <Grid item xs={12} sm={6} md={2}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="From"
            InputLabelProps={{ shrink: true }}
            name="fromDate"
            value={filters.fromDate}
            onChange={handleInputChange}
          />
        </Grid> */}

        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <Grid item xs={12} sm={6} md={2}>
            <DatePicker
              label="From"
              value={filters.fromDate || null}
              inputFormat="dd/MM/yyyy"
               sx={{height:"40px"}}
              onChange={(newValue) =>
              setFilters((prev) => ({ ...prev, fromDate: newValue }))
              }
              renderInput={(params) => (
              <TextField {...params} fullWidth size="small" />
              )}
              />
              </Grid>
        </LocalizationProvider>
        
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <Grid item xs={12} sm={6} md={2}>
            <DatePicker
              label="To"
              value={filters.toDate || null}
              inputFormat="dd/MM/yyyy"
               sx={{height:"40px"}}
              onChange={(newValue) =>
              setFilters((prev) => ({ ...prev, toDate: newValue }))
              }
              renderInput={(params) => (
              <TextField {...params} fullWidth size="small" />
              )}
              />
              </Grid>
        </LocalizationProvider>
          </Grid>

      <div className="text-end mb-3 d-flex gap-2 justify-content-end">
      <MUIButton
        variant="contained"
        color="primary"
        onClick={handleSearch}
        size="medium"
      >
    Search
  </MUIButton>

  <MUIButton
    variant="outlined"
    color="secondary"
    onClick={handleDownloadPDF}
            disabled={!filtersSearched} // ✅ only enabled if search clicked

   // disabled={!isFilterApplied()}
    size="medium"
  >
    Download PDF
  </MUIButton>

  <MUIButton
    variant="outlined"
    color="error"
    onClick={handleResetFilters}
    size="medium"
  >
    Reset
  </MUIButton>
</div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm">
          <thead className="table-light">
            <tr style={{ textAlign: "center" }}>
              <th>Sr.No</th>
              <th>ID</th>
              <th>Ride Date</th>
              <th>Customer Name</th>
              <th>Vehicle</th>
              <th>Type</th>
              <th>Status</th>
              <th>B.Date & Time</th>
              {/* <th>Booking</th> */}
              <th>Fare</th>
              <th>Payment</th>
              <th>Reservation Pdf</th>
              <th>Invoice Pdf</th>
            </tr>
          </thead>
          <tbody style={{textAlign:"center"}}>
            {filteredBookings.length > 0 ? (
              filteredBookings.map((b,index) => (
                
                
                <tr key={b._id}>
                  <td>{bookings.length - ((page - 1) * limit) - index}</td>
                  <td>{b.bookingId}</td>
                  <td>{new Intl.DateTimeFormat("en-GB", {
                      day: "2-digit",
                      month: "2-digit", // Ensures two-digit month
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                      timeZone: "UTC", // Ensures UTC format
                      }).format(parseInt(b?.date))}
                    </td>
                <td>
                  {`${b?.booking_contact_infos?.[0]?.fName || ""} ${b?.booking_contact_infos?.[0]?.lName || ""}`}
                </td>                  
                <td>{b?.vehicaltypes[0]?.vehicalName}</td>
                  <td>{b.bookingType}</td>
                  <td> {b?.failStatus === "Failed"
    ? "Failed"
    : b?.cancelStatus === "Cancelled"
    ? "Cancelled"
    : b?.status === "0"
    ? "Pending"
    : b?.status === "1"
    ? "Accepted"
    : b?.status === "2"
    ? "Processing"
    : b?.status === "3"
    ? "Completed"
    : b?.status === "4"
    ? "No Show"
    : b?.status === "5"
    ? "On Spot Cancel"
    : b?.status === "6"
    ? "Refunded"
    : ""}
                   </td>
                  <td>{new Date(b?.createdAt).toLocaleString("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}</td>
                  {/* <td>{b.type}</td> */}
                  <td>{(b?.total || 0).toFixed(2)} €</td>
                  <td>{b?.paymentType}</td>
                  <td>{b?.reservationPdfUrl ? (
                                <a
                                  href={b?.reservationPdfUrl}
                                  download
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <InsertDriveFileIcon
                                    style={{
                                      cursor: "pointer",
                                      color: "#0b2d48",
                                    }}
                                  />
                                </a>
                              ) : (
                                <span>Not Available</span>
                              )}</td>
                              <td>{b?.customerInvoiceURL ? (
                                <a
                                  href={b?.customerInvoiceURL}
                                  download
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <InsertDriveFileIcon
                                    style={{
                                      cursor: "pointer",
                                      color: "#0b2d48",
                                    }}
                                  />
                                </a>
                              ) : (
                                <span>Not Available</span>
                              )}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center">
                  No data available in table
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    Show{" "}
    <select
      className="form-select d-inline"
      style={{ width: "70px", display: "inline" }}
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setPage(1); // reset to first page
      }}
    >
      <option value={25}>25</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>{" "}
    entries
  </div>
  <div>
    <button
      className="btn btn-outline-secondary btn-sm me-2"
      disabled={page === 1}
      onClick={() => setPage((prev) => prev - 1)}
    >
      Previous
    </button>
    <span> Page {page} of {totalPages || 1} </span>
    <button
      className="btn btn-outline-secondary btn-sm ms-2"
      disabled={page === totalPages || totalPages === 0}
      onClick={() => setPage((prev) => prev + 1)}
    >
      Next
    </button>
  </div>
</div>
    </div>
  );
}

